import { useIntl } from 'react-intl'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { useAppSelector } from 'store/hooks'
import { SummaryItem } from 'components/global/Summary/components/SummaryItem'
import steps from 'index'
import { useApp } from 'store/steps'
import { useSortCardsByPerson } from 'store/unlimited-slice/hooks'
import SeparatedList from 'components/shared/SeparatedList'
import SummaryShipmentOption from './SummaryShipmentOption'
import { useNavigate } from 'react-router-dom'
import { SummaryGiftCardsList } from './SummaryGiftCardsList'

const CardsProductList = () => {
    const { formatMessage } = useIntl()
    const { stepIndex, appMode } = useApp()
    const navigateTo = useNavigate()
    const cardsToDisplay = useSortCardsByPerson()

    const { cart, items } = useAppSelector((state) => state.cart)

    const { totalPrice: cartTotalPrice, beforeDiscountPrice } = cart || {}
    const { cards, shipping } = items

    const isCardOrderStep =
        steps[stepIndex].id === 'card_order' ||
        steps[stepIndex].id === 'renew_order'
    const shippingCost = shipping?.totalPrice
    const cardsTotalPrice = (cartTotalPrice || 0) - (shippingCost || 0)

    const isUnlimitedRenew = appMode === 'unlimited-renew'
    const isRenewOrderStep = steps[stepIndex].id === 'renew_order'

    return (
        <Box gap={32} isFullWidth>
            {cards.length > 0 && (
                <>
                    <Box isFullWidth gap={18}>
                        <Box
                            direction="row"
                            isFullWidth
                            justify="space-between"
                        >
                            <Text variant="heading5" color="secondary_500">
                                {formatMessage({
                                    id: 'global.summary.section_caption_unlimited',
                                    defaultMessage: 'Karta całoroczna',
                                })}
                            </Text>
                            {(!isUnlimitedRenew || isRenewOrderStep) && (
                                <Text
                                    as="button"
                                    variant="bodyStrong"
                                    color="grayscale_700"
                                    onClick={() => navigateTo('/')}
                                    data-testid="cart-backto-edit-unlimited"
                                >
                                    {formatMessage({
                                        id: 'global.btn.edit',
                                        defaultMessage: 'Edytuj',
                                    })}
                                </Text>
                            )}
                        </Box>

                        <SeparatedList gap={12} direction="column" isFullWidth>
                            {cardsToDisplay.map((card, index) => {
                                const {
                                    description,
                                    quantity,
                                    unitPrice,
                                    name,
                                    cartItemId,
                                    totalPrice,
                                    totalPriceWithoutDiscount,
                                    hasPromotion,
                                } = card

                                return (
                                    <SummaryItem
                                        key={`${cartItemId}${index}`}
                                        name={name}
                                        quantity={quantity}
                                        description={description}
                                        price={
                                            // for unlimited renew process,
                                            // instead of individual item price,
                                            // use cart total price (differences in calculations)
                                            // (there is always only one item in cart, although bundled)
                                            isUnlimitedRenew && cardsTotalPrice
                                                ? cardsTotalPrice
                                                : unitPrice
                                        }
                                        totalPrice={totalPrice}
                                        totalPriceWithoutDiscount={
                                            // same case as above
                                            isUnlimitedRenew &&
                                            beforeDiscountPrice
                                                ? beforeDiscountPrice
                                                : totalPriceWithoutDiscount
                                        }
                                        hasPromotion={hasPromotion}
                                    />
                                )
                            })}
                        </SeparatedList>
                        <SummaryGiftCardsList />
                    </Box>

                    {isCardOrderStep && (
                        <Box isFullWidth>
                            <Box
                                isFullWidth
                                direction="row"
                                justify="space-between"
                                mb={18}
                            >
                                <Text variant="heading5" color="secondary_500">
                                    {formatMessage({
                                        id: 'global.summary.section_caption_shipment_method',
                                        defaultMessage: 'Sposób dostawy',
                                    })}
                                </Text>
                            </Box>

                            <SummaryShipmentOption
                                shippingCost={shippingCost}
                                freeShippingType="park"
                            />
                        </Box>
                    )}
                </>
            )}
        </Box>
    )
}

export default CardsProductList
